import type { PreOrderFlow } from "@stockline/shared/types/orders/pre-order-flow"
import type { OfflineResourceConfig } from "../../../types"
import { PRE_ORDER_FLOW_TABLE } from "./db"

export const preOrderFlowConfig: OfflineResourceConfig<PreOrderFlow> = {
  name: "pre-order-flows",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  // HOT via the PARENT pre-order — flows' own delivery_date is ~56% NULL, so
  // the server computes the floor by JOINing the parent. The client sends the
  // same windowStart and stores the returned child floor. STK-1322.
  tier: "hot",
  windowedBy: "pre-orders",
  // 7-day rolling window (STK-1927) — mirrors the parent pre-order window; the
  // server computes the child floor from the JOINed parent. Ships with the
  // anchor re-stamp (STK-1925).
  window: { days: 7 },
  // ~0.8 KB/row but the highest row count (~50k for large tenants). 2000/page
  // bounds the request count on catalogue-bound tenants (Delanchy ~36 pages
  // @500 → ~9 @2000, ~536KB→~2.1MB decoded per page, under the API's served
  // ceiling) while keeping each stringify short. STK-1960.
  pageSize: 2000,
  endpoints: {
    full: "/api/v2/pre-order-flows",
    delta: "/api/v2/pre-order-flows/changes",
    push: "/api/v2/pre-order-flows/changes",
  },
  tableName: PRE_ORDER_FLOW_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    preOrderId: "preOrderId",
    productId: "productId",
    status: "status",
    deletedAt: "deletedAt",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
  // Flow tombstones must stay in the offline store so a soft-deleted parent's
  // pre-order panel can still render the historical flow rows under "show
  // deleted". `usePreOrderFlows` filters tombstones by default.
  softDelete: true,
}
